module.exports = __webpack_public_path__ + "media/components/assets/img/bg/panorama-4880fdc93e84f2cb6378ab528583c391.svg";